import { getLimitOptions } from 'utilities/query';
import templateUrl from './user-list.html';

export default {
  templateUrl,
  bindings: {
    users: '<',
    selectedUsers: '<',
    userLockoutChanged: '&',
    locked: '<',
    query: '<',
    queryChanged: '&',
    searchTextChanged: '&',
    showColumns: '<'
  },
  controller: class UserListComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });

      this.onPaginationChanged = (page, take) => {
        this.onQueryChange({
          ...this.query,
          page,
          take
        });
      };

      this.onOrderChanged = (order) => {
        const direction = order.indexOf('-') !== -1 ? 'desc' : 'asc';
        const orderBy = order.replace('-', '');

        this.onQueryChange({
          ...this.query,
          direction,
          orderBy
        });
      };
    }

    $onInit() {
      this.limitOptions = getLimitOptions();
    }

    setUserLocked(user) {
      this.userLockoutChanged(
        this.EventEmitter({
          userId: user.UserId,
          isLocked: !user.IsLocked
        })
      );
    }

    onQueryChange(query) {
      this.queryChanged(
        this.EventEmitter({
          query
        })
      );
    }

    onSearchTextChanged(searchText) {
      this.searchTextChanged(
        this.EventEmitter({
          searchText
        })
      );
    }

    shouldShowColumn(columnName) {
      if (!(this.showColumns && this.showColumns.length)) {
        return false;
      }

      return this.showColumns.indexOf(columnName) > -1;
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/common/user-list/user-list.component.js